import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  PARAM_FOUNDERS_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { AbstractListController } from "../../common/abstract-list.component";
import { Founder } from "src/app/models/founder";
import { FoundersService } from "src/app/services/founders.service";
import { CommonModule } from "@angular/common";
import { DataTableComponent } from "../../common/data-table/data-table.component";
import {
  TableColumn,
  TableFilter,
} from "../../common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-founders",
  templateUrl: "./manage-founders.component.html",
  imports: [CommonModule, DataTableComponent],
})
export class ManageFoundersComponent extends AbstractListController<
  Founder,
  any
> {
  title = "Founders";

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    {
      field: "name",
      header: "Name",
      type: "link",
      link: (row) => ["/admin/founders/edit", row.id],
    },
    { field: "headline", header: "Headline" },
    { field: "country", header: "Country" },
    {
      field: "status",
      header: "Status",
      type: "tag",
      tagMap: {
        1: { label: "active", severity: "success" },
        0: { label: "not active", severity: "danger" },
      },
    },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "name", header: "Name", type: "string" },
    { field: "country", header: "Country", type: "string" },
    {
      field: "status",
      header: "Status",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  tableFilterValues: Record<string, any> = {};

  editLink = (row: Founder): any[] => ["/admin/founders/edit", row.id];

  constructor(
    private foundersService: FoundersService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      foundersService,
      confirmationService,
      router,
      route,
      PARAM_FOUNDERS_PATH,
    );
    this.useTableFilters = true;
  }
}
